import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=7522033c&scoped=true&"
import script from "./UsersList.vue?vue&type=script&lang=js&"
export * from "./UsersList.vue?vue&type=script&lang=js&"
import style0 from "./UsersList.vue?vue&type=style&index=0&id=7522033c&lang=scss&scoped=true&"
import style1 from "./UsersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7522033c",
  null
  
)

export default component.exports